import * as React from "react"
import { Symbols } from "@tenforce/toolbox-fontmap"

import { Modal } from "@tenforce/toolbox-modal-react"
import { Action, ActionType } from "@tenforce/toolbox-button-push-react"

import SelectedWidgets from "./SelectedWidgets"
import { Labels } from "../../../../util/Translations"

interface Props {
    isLoading: boolean
    grid: Grids.Grid
    reorderTiles: (
        targetIndex: number,
        oldIndex: number,
        reorderedTileId: number,
        targetTileId: number,
    ) => void
    removeTile: (tileId: number) => void
}

interface State {
    isShown: boolean
}

export default class GridConfiguration extends React.PureComponent<
    Props,
    State
> {
    constructor(props: Props) {
        super(props)

        this.state = {
            isShown: false,
        }
    }

    render(): JSX.Element {
        const { grid, isLoading, reorderTiles, removeTile } = this.props
        const { isShown } = this.state
        const { GridConfiguration } = Labels

        if (grid.id === -1) {
            return <></>
        }

        return (
            <>
                <Action
                    actionType={ActionType.icon}
                    id="gridConfigurationButton"
                    onClick={this.showModal}
                    title={GridConfiguration}
                    isLoading={isLoading}
                >
                    {Symbols.WorkspaceGridSettings}
                </Action>
                <Modal
                    isShown={isShown}
                    containerProps={{
                        id: "gridConfigurationModal",
                        isCenterPositioned: true,
                        onClose: this.hideModal,
                    }}
                    contentProps={{
                        extraClasses: "tw-my-1/20 tw-mx-1/5",
                    }}
                >
                    <div className="tw-flex tw-items-start tw-justify-center">
                        <SelectedWidgets
                            grid={grid}
                            isLoading={isLoading}
                            reorderTiles={reorderTiles}
                            removeTile={removeTile}
                        />
                    </div>
                </Modal>
            </>
        )
    }

    showModal = (): void => this.setState({ isShown: true })

    hideModal = (): void => this.setState({ isShown: false })
}
